<!-- 決済方法 -->
<template>
  <div class="row">
    <label class="name">決済方法</label>
    <div class="value">{{ label }}</div>
  </div>
</template>

<script>
export default {
  name: "PaymentMethod",
  props: {
    label: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.row {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  font-size: 14px;
}

.row label {
  width: 110px;
  font-weight: normal;
  color: #888888;
}

.row .value {
  width: calc(100% - 110px);
  font-weight: bold;
}
</style>
